import { render, staticRenderFns } from "./QuizRootTopicView.vue?vue&type=template&id=f672f3d8"
import script from "./QuizRootTopicView.vue?vue&type=script&lang=js"
export * from "./QuizRootTopicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports